import Vue from 'vue'

const state = {
  weightRangeMax: 999999000,

  viewSeFeeType: 'busi', // frt | tax | busi
  viewAirFeeType: 'busi', // frt | tax | busi
}

const getters = {
  // 格式化重量範圍
  // return [{start: 1000, end: 5000, fee: 12}, ...]
  formatWeightRanges: (state, getters) => (sr) => {
    const wrs = []
    for (let n = 0; n < 10; n++) {
      if (sr[`w${n}Fee`] > 0) {
        wrs[n] = { start: (parseInt(sr[`w${n - 1}`]) || 0) + 1000, end: sr[`w${n}`], fee: sr[`w${n}Fee`] }
      }
    }
    return wrs
  },
  // 输入给定的重量，确认重量范围
  // return {start: 1000, end: 5000, fee: 12}
  getWeightRange: (state, getters) => (sr, weight) => {
    let weightRange = {}
    if (weight > 1000) {
      weight = parseInt(weight / 100) * 100 // 去掉尾重小于0.099KG
    }
    for (let n = 0; n < 10; n++) {
      if (sr[`w${n}Fee`] > 0) {
        weightRange = {
          start: (parseInt(sr[`w${n - 1}`]) || parseInt(sr.minWeight)) + 1000,
          end: sr[`w${n}`],
          fee: sr[`w${n}Fee`]
        }
        if (weight <= sr[`w${n}`]) {
          break
        }
      }
    }
    return weightRange
  },

  // 首重和續重
  renderFirstAddlWeight: (state, getters) => (sr) => {
    const firstWeight = Vue.options.filters.toKg(sr.firstWeight)
    const addlWeight = Vue.options.filters.toKg(sr.addlWeight)

    return `
      首重：
      <span class="indigo--text">${firstWeight}</span> KG
      <span class="purple--text">${Vue.options.filters.toCurrency(sr.fwFee)}</span> 元
      <br>
      續重：
      <span class="indigo--text">${addlWeight}</span> KG
      <span class="purple--text">${Vue.options.filters.toCurrency(sr.awFee)}</span> 元`
  },
  // 首重
  renderFirstWeight: (state, getters) => (sr) => {
    const firstWeight = Vue.options.filters.toKg(sr.firstWeight)

    return `
      <span class="purple--text">${Vue.options.filters.toCurrency(sr.fwFee)}</span> 元 /
      <span class="indigo--text" hidden>${firstWeight}</span> KG
      `
  },
  // 重量范围
  // weightRanges: [{start: 1000, end: 5000, fee: 12}, ...]
  renderWeightRange: (state, getters) => (weightRanges) => {
    let trs = ''
    for (const i in weightRanges) {
      const wr = weightRanges[i]
      const start = Vue.options.filters.toKg(wr.start)
      const end = Vue.options.filters.toKg(wr.end)
      trs += `
        <tr>
          <td class="pa-0" nowrap style="height:auto">
            <span class="indigo--text">${start}</span>
          </td>
          <td class="pa-0" nowrap style="height:auto">
            - <span class="indigo--text">${wr.end < state.weightRangeMax ? end : '以上'}</span> KG
          </td>
          <td class="pa-0" nowrap style="height:auto">
            <span class="purple--text">${Vue.options.filters.toCurrency(wr.fee)}</span> 元 / KG
          </td>
        </tr>`
    }
    return `<table><tbody>${trs}</tbody></table>`
  },
  // 重量不足，加收派送費
  renderLessWeight: (state, getters) => (sr, jyWeight) => {
    if (sr.lwFee > 0 && jyWeight <= sr.lessWeight) {
      return `加收派送費 <span class="purple--text">${Vue.options.filters.toCurrency(sr.lwFee)}</span> 元`
    }
    return parseInt(sr.lwFee) === 0 ? '含派送費' : '不含派送費'
  },
  // 重量不足，加收清關費
  renderCsLessWeight: (state, getters) => (sr, jyWeight) => {
    if (sr.csFee > 0 && jyWeight <= sr.csLessWeight) {
      return `加收清關費 <span class="purple--text">${Vue.options.filters.toCurrency(sr.csFee)}</span> 元`
    }
    return parseInt(sr.csFee) === 0 ? '含清關費' : '不含清關費'
  },
  // 重量不足，加收稅費
  renderTaxLessWeight: (state, getters) => (sr, jyWeight) => {
    if (sr.taxFee > 0 && jyWeight <= sr.taxLessWeight) {
      const taxFee = Math.ceil(jyWeight / 1000) * sr.taxFee
      return `稅費 <span class="purple--text">${Vue.options.filters.toCurrency(taxFee)}</span> 元`
    }
    return parseInt(sr.taxFee) === 0 ? '包稅' : '不包稅'
  }
}

const mutations = {
  setViewSeFeeType (state, v) {
    state.viewSeFeeType = v
  },
  setViewAirFeeType (state, v) {
    state.viewAirFeeType = v
  },
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/shippingrate/index', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
